import $ from 'jquery';
import React, { useEffect } from 'react';


const Video = () => {
    useEffect(() => {
        // Youtube
        var $ytvideoTrigger = $(".ytplay_btn");
        $ytvideoTrigger.on("click", function (evt) {
            $(".ytube_video").addClass("play");
            $("#ytvideo")[0].src += "?autoplay=1";
        });


        // Local
        var $videoTrigger = $(".play_btn");
        var $videoContainer = $(".local_video");
        $videoTrigger.on("click", function (evt) {
            if ($videoContainer.hasClass("play")) {
                $videoContainer
                    .removeClass("play")
                    .find("video").get(0).pause();
            }
            else {
                $videoContainer
                    .addClass("play")
                    .find("video").get(0).play();
            }
        });
    }, []);

    return (
        <div className="video_sec">
            <div className="video-banner bg_image_6">
                <div className="video-content">Watch Hungrybuzz <span className="video_btn"><a data-fancybox="video" href="http://www.youtube.com/watch?v=opj24KnzrWo"><img src="images/play_btn.png" alt="" /></a></span> Cooking Videos</div>
            </div>
        </div>
    );
};

export default Video;